import React, { Component } from 'react'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Rodal from 'rodal'
import moment from 'moment'
import selectors from '../../../../store/shared/selectors'
import * as adminTasksAssignmentDuck from '../adminTasksAssignmentDuck'
import AssignTaskToStudentsForm from './AdminAssignTaskToStudentsForm'


/**
 * @class StudentTasksCreateModal
 * @description Modal container that controls ability to add tasks to Students
 */
class StudentTasksCreateModal extends Component {

  /**
   * @static propTypes
   */
  static propTypes = {
    activeTask: PropTypes.any.isRequired,
    activeTasksByType: PropTypes.any.isRequired,
    formValues: PropTypes.any.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    performAssignTaskToStudents: PropTypes.func.isRequired,
    performRetrieveAssignedStudentTasks: PropTypes.func.isRequired,
    studentSignups: PropTypes.array.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired
  }

  /**
   * @constructor
   * @param props
   */
  constructor(props) {
    super(props)

    /**
     * @method createTask
     * @description Fires a Redux action to create the Task
     * @description Parses out the stringified version of who to assign to
     * @description Creates the params object
     * @description Re-retrieves the Tasks
     * @description Toggles the modal shut
     */
    this.createTask = () => {
      const { activeTask, formValues, toggleModal } = this.props
      const assignedTo = Object.keys(JSON.parse(formValues.assignedTo))
      this.props.performAssignTaskToStudents({
        ...formValues,
        assignedTo,
        type: activeTask.activeTaskType,
      })
        .then(this.props.performRetrieveAssignedStudentTasks)
        .then(() => toggleModal('', ''))
        .catch(console.error)
    }

    /**
     * @method getPertinentUsersForTasks
     * @description Narrows down the users who are default selected when editing an existing task
     * @param activeTask
     * @param activeTasksByType
     * @param studentSignups
     * @returns {*}
     */
    this.getPertinentUsersForTasks = (activeTask, activeTasksByType, studentSignups) => {
      const pertinentTasks = activeTasksByType[activeTask.activeTaskType]

      if (!pertinentTasks) return { task: null, users: [] }

      const studentIds = pertinentTasks.map(item => item.assignedTo._id)
      return {
        task: pertinentTasks[0],
        users: studentSignups.filter(item => includes(studentIds, item._id))
      }
    }
  }

  /**
   * @method render
   */
  render() {
    const { activeTask, activeTasksByType, isFetching, isModalOpen, toggleModal, studentSignups, isMobile } = this.props

    const { task, users } = this.getPertinentUsersForTasks(activeTask, activeTasksByType, studentSignups)

    /**
     * @const formValues
     * @description Form values that should be set on a user when an activeTask is selected
     * @type {{dueDate: string, assignedTo: *}}
     */
    const formValues = {
      dueDate: task ? moment(task.dueDate).toISOString() : moment().add(1, 'days').toISOString(),
      description: task ? task.description : activeTask.taskType.content,
      assignedTo: task ? JSON.stringify(users.reduce((acc, item) => {
        acc[item._id] = item
        return acc
      }, {})) : JSON.stringify({})
    }

    return (
      <Rodal
        visible={isModalOpen}
        measure="%"
        customStyles={{maxWidth: 600, width: '90%', maxHeight: '90%', overflowY: 'scroll'}}
        customMaskStyles={{ opacity: 0.9, backgroundColor: 'black' }}
        onClose={() => toggleModal('', '')}
        duration={300}
      >
        <h6>Assign a Task to your Students</h6>
        <h5>Task Type: <strong>{activeTask.activeTaskName}</strong></h5>
        <AssignTaskToStudentsForm
          isFetching={isFetching}
          formValues={formValues}
          listData={studentSignups}
          onSubmit={this.createTask}
          isMobile={isMobile}
          initialValues={{
            dueDate: moment().add(7, 'days').toISOString(),
            assignedTo: JSON.stringify({}),
          }}
        />
      </Rodal>
    )
  }
}

const mapStateToProps = state => ({
  isFetching: selectors.getIsPerformingRequest(state, 'studentTasksAssignment'),
  formValues: selectors.getReduxFormValues(state.form.adminAssignTaskToStudentsForm),
  activeTask: adminTasksAssignmentDuck.getActiveTask(state),
  activeTasksByType: adminTasksAssignmentDuck.getAssignedTasksByType(state),
  isModalOpen: adminTasksAssignmentDuck.getModalState(state),
  isMobile: selectors.isLessThanMedium(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleModal: adminTasksAssignmentDuck.toggleModal,
  performAssignTaskToStudents: adminTasksAssignmentDuck.performAssignTask,
  performRetrieveAssignedStudentTasks: adminTasksAssignmentDuck.performRetrieveTasks,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(StudentTasksCreateModal)



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/StudentTasksCreateModal.js